import { render } from "./ProductOverview.vue?vue&type=template&id=06abe11d&scoped=true&ts=true"
import script from "./ProductOverview.vue?vue&type=script&lang=ts"
export * from "./ProductOverview.vue?vue&type=script&lang=ts"

import "./ProductOverview.vue?vue&type=style&index=0&id=06abe11d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06abe11d"]])

export default __exports__